import { ResourceService } from '@ixicare/resources';
import TokenService from '~services/TokenService';

export function setResources() {
  ResourceService.init(TokenService);
}
